//export const baseURL = 'http://118.118.118.200:17781/mrp/v1/'
const codeUrl = 'http://118.118.118.20:8089/'
export const baseURL = 'http://bi.dacube.com.cn:8084/search.com/'  //线上环境
//export const baseURL = 'http://bi.dacube.com.cn:8084/search.com/' //测试环境


import { Loading } from 'element-ui'
import Vue from 'vue'
Vue.use(Loading)
import Vuex from 'vuex'
import stores from '../stores'

Vue.use(Vuex)
var store = new Vuex.Store(stores)

const cookie = require('browser-cookies')
var axios = require('axios').create({
  baseURL: baseURL,
  //withCredentials: false, // 允许跨域 cookie
  headers: {
    //'X-Requested-With': 'XMLHttpRequest',
    "Content-Type": "application/json;charset=UTF-8"
  }
})

var loadingIns = null
axios.interceptors.response.use(function (response) {
  // Do something with response data
  resValidator(response)
  loadingIns.close()
  return response;
}, function (error) {
  loadingIns.close()
  resValidator(error)
  return Promise.resolve({});
});

function resValidator(params) {
  if (params && params.response) {
    if (params.response.status == 401 || params.response.status == 403) {
      window.location.href = 'https://center.dacube.cn/#/login/index' //线上环境
      //window.location.href = 'http://center.t.dacube.cn/' //测试环境
    }
    if (params.response.data.code == 401 || params.response.data.code == 403) {
      window.location.href = 'https://center.dacube.cn/#/login/index' //线上环境
      //window.location.href = 'http://center.t.dacube.cn/'  //测试环境
    }
  }
}
//global axios interceptor
axios.interceptors.request.use(function (config) {
  loadingIns = Loading.service({ fullscreen: true })
  return config;
}, function (error) {
  loadingIns.close()
  return Promise.reject(error);
});


export const _post = (url, option) => {
  setReqHeader()
  return axios.post(url, option)
}

export const _get = (url, option) => {
  //setReqHeader()
  return axios.get(url, { params: option });
}
export const setReqHeader = (param) => {
  axios.defaults.headers.common['token'] = param || localStorage.getItem('token')
}











// WEBPACK FOOTER //
// ./src/api/index.js